import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { DwellTimeWrapper } from "../../components/dwell-time-wrapper";
import ErrorBoundary from "../../components/percieved-provisioning/error-boundary/error-boundary";
import { TemplateChoiceView } from "../../components/template-choice/template-choice-view";
import { useJiraTemplateChoice } from "../../hooks/use-jira-template-choice";
import { useSearchParameters } from "../../hooks/use-search-parameters";
export const TemplateChoiceScreen = () => {
    const { setTemplateChoiceError } = useJiraTemplateChoice();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { products, edition, jtbd, teamType } = useSearchParameters();

    const onError = useCallback(
        (error: Error) => {
            createAnalyticsEvent({
                actionSubject: "confirmationPageScreen",
                action: "failed",
                actionSubjectId: "TemplateChoiceScreen",
                attributes: {
                    products,
                    edition,
                    jtbd,
                    teamType
                }
            }).fire();
            setTemplateChoiceError(error);
        },
        [createAnalyticsEvent, setTemplateChoiceError]
    );

    return (
        <ErrorBoundary onError={onError}>
            <DwellTimeWrapper
                eventData={{
                    action: "dwelled",
                    actionSubject: "screen",
                    actionSubjectId: "TemplateChoiceScreen",
                    source: "/ondemand/signup/confirmation",
                    attributes: {
                        atlasId: "ATLAS-58859"
                    }
                }}
                initialPollInterval={5000}
                idleTimeout={120000}
                nextPollIntervalCallback={(x) => x + 5000}
            >
                <TemplateChoiceView />
            </DwellTimeWrapper>
        </ErrorBoundary>
    );
};
